<template>
<div class="chapter">
<div class="inner_page">
<p><a id="toc"></a></p>
<div class="fmh1">Table of Contents</div>
<div> <br/></div>
<div class="cfmh"><span href="#/henn_9781595586124_oeb_tp_r1" title="Link target outside of Sample">Title Page</span></div>
<div class="cfmh"><a href="#/henn_9781595586124_oeb_fm2_r1">The Fifth Woman</a></div>
<div class="cfmh"><a href="#/henn_9781595586124_oeb_epi_r1">Epigraph</a></div>
<div class="cfmh"><a href="#/henn_9781595586124_oeb_fm3_r1">Africa—Sweden</a></div>
<div class="cfmh"><a href="#/henn_9781595586124_oeb_fm4_r1">Prologue</a></div>
<div> <br/></div>
<div class="cpt"><a href="#/henn_9781595586124_oeb_p01_r1">Skåne - 21 September—11 October 1994</a></div>
<div class="cct"><a href="#/henn_9781595586124_oeb_c01_r1">Chapter One</a></div>
<div class="cct"><a href="#/henn_9781595586124_oeb_c02_r1">Chapter Two</a></div>
<div class="cct"><a href="#/henn_9781595586124_oeb_c03_r1">Chapter Three</a></div>
<div class="cct"><a href="#/henn_9781595586124_oeb_c04_r1">Chapter Four</a></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c05_r1" title="Link target outside of Sample">Chapter Five</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c06_r1" title="Link target outside of Sample">Chapter Six</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c07_r1" title="Link target outside of Sample">Chapter Seven</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c08_r1" title="Link target outside of Sample">Chapter Eight</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c09_r1" title="Link target outside of Sample">Chapter Nine</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c10_r1" title="Link target outside of Sample">Chapter Ten</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c11_r1" title="Link target outside of Sample">Chapter Eleven</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c12_r1" title="Link target outside of Sample">Chapter Twelve</span></div>
<div> <br/></div>
<div class="cpt"><span href="#/henn_9781595586124_oeb_p02_r1" title="Link target outside of Sample">Skåne - 12—17 October 1994</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c13_r1" title="Link target outside of Sample">Chapter Thirteen</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c14_r1" title="Link target outside of Sample">Chapter Fourteen</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c15_r1" title="Link target outside of Sample">Chapter Fifteen</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c16_r1" title="Link target outside of Sample">Chapter Sixteen</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c17_r1" title="Link target outside of Sample">Chapter Seventeen</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c18_r1" title="Link target outside of Sample">Chapter Eighteen</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c19_r1" title="Link target outside of Sample">Chapter Nineteen</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c20_r1" title="Link target outside of Sample">Chapter Twenty</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c21_r1" title="Link target outside of Sample">Chapter Twenty-one</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c22_r1" title="Link target outside of Sample">Chapter Twenty-two</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c23_r1" title="Link target outside of Sample">Chapter Twenty-three</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c24_r1" title="Link target outside of Sample">Chapter Twenty-four</span></div>
<div> <br/></div>
<div class="cpt"><span href="#/henn_9781595586124_oeb_p03_r1" title="Link target outside of Sample">Skåne - 17 October—3 November 1994</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c25_r1" title="Link target outside of Sample">Chapter Twenty-five</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c26_r1" title="Link target outside of Sample">Chapter Twenty-six</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c27_r1" title="Link target outside of Sample">Chapter Twenty-seven</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c28_r1" title="Link target outside of Sample">Chapter Twenty-eight</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c29_r1" title="Link target outside of Sample">Chapter Twenty-nine</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c30_r1" title="Link target outside of Sample">Chapter Thirty</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c31_r1" title="Link target outside of Sample">Chapter Thirty-one</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c32_r1" title="Link target outside of Sample">Chapter Thirty-two</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c33_r1" title="Link target outside of Sample">Chapter Thirty-three</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c34_r1" title="Link target outside of Sample">Chapter Thirty-four</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c35_r1" title="Link target outside of Sample">Chapter Thirty-five</span></div>
<div class="cct"><span href="#/henn_9781595586124_oeb_c36_r1" title="Link target outside of Sample">Chapter Thirty-six</span></div>
<div> <br/></div>
<div class="cbmh"><span href="#/henn_9781595586124_oeb_bm1_r1" title="Link target outside of Sample">Skåne</span></div>
<div class="cbmh"><span href="#/henn_9781595586124_oeb_elg_r1" title="Link target outside of Sample">Epilogue</span></div>
<div class="cbmh"><span href="#/henn_9781595586124_oeb_cop_r1" title="Link target outside of Sample">Copyright Page</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// henn_9781595586124_oeb_toc_r1.vue?57abeb36